import { Component, OnInit } from '@angular/core';
import { DocumentData } from '../../../interfaces/section';
import { PoliciesStyleComponent } from "../policies-style/policies-style.component";
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy',
  standalone: true,
  imports: [PoliciesStyleComponent],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.scss'
})
export class PrivacyComponent implements OnInit {
  documentData!: DocumentData;

  constructor(private translate: TranslateService) {}

  ngOnInit(): void {
    this.load();
    this.translate.onLangChange.subscribe(() => this.load());
  }

  private load(): void {
    this.documentData = this.translate.instant('policies.privacy');
  }
}
